/**
 * Privacy Policy - English v1
 * 
 * Source: public/privacy.html (Official Pi Network submission)
 */
export const PRIVACY_V1_EN = {
    version: "v1",
    effectiveDate: "2025-10-15",
    language: "en",
    title: "Privacy Policy",
    content: `
Privacy Policy for Spot Go

Last Updated: October 15, 2025 (KST)

This Privacy Policy explains how the developer of Spot Go ("Developer," "we," "us," or "our") collects, uses, and discloses your information when you use our game, Spot Go (the "Service").

1. Information We Collect

We collect and store only the data necessary to operate and improve the Service.

1.1 Pi Network Account Information

We receive your unique Pi Network User ID when you log in to our Service. We do not receive or store your Pi Network password.

1.2 In-Game Identification and Records

We receive your Pi Network nickname and user ID through the Pi Network login process and store them on our servers for account management, leaderboard ranking, and payment record purposes. This information is linked to your gameplay data (such as scores and purchases) but cannot be modified within our Service.

1.3 Usage Data

We may collect data about your device and how you interact with our Service through analytics tools to help us improve the user experience.

2. How We Use Your Information

• Provide and maintain the Service
• Manage your account and save your game progress
• Analyze and improve the Service
• Protect the security and integrity of the Service and prevent cheating

2-1. Public Display of Nicknames

To provide ranking and competitive features, your Pi Network nickname may be publicly displayed to other users within the Service (for example, in leaderboards or rankings). We store this information securely on our servers but publicly display only your nickname and score. Other personal or payment details are never shared with other users.

3. Sharing Your Information

We do not sell or rent your personal information. We may share your information only as described below:

• With Service Providers: For example, Firebase is used for cloud hosting and database management.
• For Legal Reasons: We may disclose information if required by law or to protect the rights, property, or safety of ourselves, our users, or others.

4. Data Deletion

You may request deletion of your game data by emailing lukep81@painori.com with the subject "Data Deletion Request." Upon processing, we will permanently delete all game data (including progress and scores). If you access the Service again after deletion, a new profile will be created.

5. Data Security and Retention

We use reasonable technical and organizational measures to protect your data, but no method of transmission over the internet is 100% secure. We retain your data only as long as your account remains active or as required by applicable law.

6. International Data Transfers

Your data may be transferred to and maintained on servers outside your country. By using our Service, you consent to this transfer.

7. Children's Privacy

Our Service is not intended for children under 14. We do not knowingly collect data from children. If we learn that we have inadvertently collected such data, we will delete it promptly.

8. Contact Us

If you have any questions about this Privacy Policy, contact us at: lukep81@painori.com
`.trim()
};
